const messages = {
  close: 'Close',
  file: 'File',
  goBack: 'Go Back to Excel Import',
  newOrderAddedToCart: 'New order added to your cart',
  newPendingOrderCreated: 'New Pending order created',
  excelOrders: 'Excel Orders',
  poNumber: 'PO#',
  result: 'Result',
}

export default messages
